import React, { useCallback } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { access, defaultRoute } from '../../../../common/Tool';
import { BreadcrumbsProvider, MenuLevelThreeContext, MenuLevelThreeElementContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext, useOrganizerContext } from '../../../../common/Context';
import Accounts from '../../Accounts';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Finance(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const { menu: m } = props;

    // const [org, setOrg] = useOrganizerContext();
    const menu = useCallback((status, notify) => {
        const x = [
            {
                uuid: "accounts",
                name: "Счета",
                default: true,
                component: (props) => (<Accounts {...props} ctx={{organizatorFederatsiyaID: 1}}/>),
                role: [
                    { "ID": 23, "nazvanie": "ОрганизаторФедерации" },
                ],
            },
        ]
        return x
    },[]);

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <MenuLevelThreeContext.Provider value={menu(status, notify)}>
        {(!siteAccess || siteAccess == "allow") && <Routes>
            {defaultRoute(menu(status, notify), role_by_id)}
            {menu(status, notify).map((e, idx) => {
                if (e.component && access(e, role_by_id)) {

                    return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                        <BreadcrumbsProvider value={{
                            uuid: e?.uuid,
                            name: e?.name,
                            color: e?.color,
                            role: e?.role,
                            hidden: e.hidden
                        }}>
                            {e.component({})}
                        </BreadcrumbsProvider>} />

                }
            })}
        </Routes>}
    </MenuLevelThreeContext.Provider>
    );
}
